// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
// @ts-ignore
import {ga_track_download_send} from '../ga.js';
// @ts-ignore
import {get_exe_link} from '../install_links.js';
// @ts-ignore
import {download_file} from '../install_util.js';
import hopt from 'hola_opt';
// @ts-ignore
import {qs_parse, qs_str} from '/util/url.js';
import {Agree_dialog} from '../ui/agree_dialog';
// @ts-ignore
import {perr} from '../util.js';
import {useHistory} from 'react-router-dom';
// @ts-ignore
import {App_context} from '../context.js';

interface i_agree_window_props {
    agree: string;
    set_agree: any;
    page_id: string;
    just_question?: boolean;
    next_url?: string;
    prev_url?: string;
    opt?: object_of<boolean>;
    ver?: number;
    ref_id?: string;
    need_exp?: boolean;
    skip_download?: boolean;
}
const Agree_window = ({agree, set_agree, page_id, just_question, prev_url,
    next_url, opt, ref_id='unknown', skip_download}
    :i_agree_window_props)=>{
    const history = useHistory();
    const {has_svc} = useContext(App_context);
    const on_close = ()=>{
        set_agree({agree: ''});
        history.push(prev_url);
    };
    const on_agree_hdl = ()=>{
        perr({id: `www_${ref_id}_agree_click`});
        if (skip_download!==true)
        {
            const install_opt = {
                has_svc: has_svc,
                agree: !just_question, os: agree=='mac_beta' ? 'macos' : agree,
                ...opt};
            const link = get_exe_link(install_opt);
            ga_track_download_send(agree=='mac_beta' ? 'dmg' : 'exe',
                page_id || 'download', link, null, undefined, install_opt);
            download_file(link);
        }
        set_agree({agree: ''});
        if (next_url)
            history.push(next_url);
    };
    if (!agree)
        return null;
    return <Agree_dialog on_agree={on_agree_hdl} on_close={on_close}/>;
};

const qs_o = ()=>qs_parse(window.location.search.substr(1), {safe: true});
interface i_use_agree_props {
    ref_id: string;
    just_question?: boolean;
    need_agree?: boolean;
}
export const use_agree = ({ref_id, just_question, need_agree}:
    i_use_agree_props)=>{
    const [agree, set_agree] = useState({agree: '', next_url: '',
        prev_url: ''});
    const history = useHistory();
    const qs = qs_o();
    const need_agree_calc = need_agree || qs.test_exe_agree ||
        !!hopt.www_hola.agree_for_exe_downloading2;
    const on_click = (ev, app, next_url)=>{
        if ((app.name=='windows' || app.name=='mac_beta' || app.name=='macos')
            && need_agree_calc)
        {
            if (ev)
                ev.preventDefault();
            if (!qs.consent)
            {
                history.push(location.pathname+'?'+qs_str({
                    ...qs,
                    consent: app.name,
                    next_url: next_url,
                    prev_url: location.pathname+location.search,
                }));
            }
        }
    };
    useEffect(()=>{
        if (qs.consent)
        {
            perr({id: `www_${ref_id}_open_modal`});
            set_agree({
                agree: qs.consent,
                next_url: decodeURIComponent(qs.next_url),
                prev_url: decodeURIComponent(qs.prev_url),
            });
        }
    }, [qs.consent]);
    return {a_props: {...agree, set_agree, just_question, ref_id},
        Agree_window, on_click};
};
